export default {
  education: {
    webinar: {
      title: "برای دسترسی به ضبط برای این رویداد ثبت نام کنید",
      text: "شما می توانید به طور خودکار با داده های حساب جاری خود وارد شوید یا داده ها را به صورت دستی در مرحله بعدی وارد کنید.",
      label: "با ثبت نام قبول می کنید",
      link: "شرایط انتقال به شریک خدمات Mts Link",
      close: "داده ها را به صورت دستی وارد کنید",
      submit: "ثبت نام کنید",
    },
    metaTitle: "آموزش",
    noContentLang: "هنوز هیچ مطلبی به این زبان منتشر نشده است.",
    titles: {
      material: "آموزش برای پزشکان",
      course: "دوره‌های آموزشی برای پزشکان",
      simulator: "شبیه‌سازها برای پزشکان",
      webinar: "وبینارها برای پزشکان",
    },
    filters: {
      selects: {
        type: {
          placeholder: "نوع مواد",
        },
        lang: {
          placeholder: "زبان",
        },
        status: {
          placeholder: "وضعیت",
          values: {
            actual: "جاری",
            overpast: "گذشته",
          },
        },
        specialty: {
          placeholder: "تخصص",
        },
      },
      tabs: {
        material: "همه مطالب",
        course: "دوره‌ها",
        simulator: "شبیه‌سازها",
        webinar: "وبینارها",
      },
    },
    content: {
      subtitles: {
        your: {
          material: "مطالب شما",
          course: "دوره‌های شما",
          simulator: "شبیه‌سازهای شما",
          webinar: "وبینارهای شما",
        },
        recomended: {
          material: "مطالب پیشنهادی",
          course: "دوره‌های پیشنهادی",
          simulator: "شبیه‌سازهای پیشنهادی",
          webinar: "وبینارهای پیشنهادی",
        },
      },
    },
  },
  Lessons: {
    Lesson: {
      title: "درس",
      Files: "پیوست‌ها",
      DownloadAll: "دانلود همه",
    },
    status: {
      success: "موفق",
      unsuccess: "ناموفق",
      stop: "غیرفعال",
    },
  },
  Tests: {
    table: {
      tests: "آزمون‌ها",
      description: "توضیحات",
      points: "امتیاز",
      status: "وضعیت",
    },
    modal: {
      title: "آیا می‌خواهید آزمون را به پایان برسانید؟",
    },
    questions: {
      question: "سوال",
      answer: "پاسخ",
      correct: "صحیح",
      incorrect: "غلط",
      moderated: "در حال بررسی",
      navigation: "پیمایش آزمون",
      enterAnswer: "پاسخ را وارد کنید...",
    },
    errors: {
      required: "سوال اجباری",
    },
    submit: "اتمام آزمون",
    result: "نتیجه",
    repeat: "تکرار آزمون",
  },
  afterPayCourse: {
    title: "شما با موفقیت این دوره را خریداری کرده اید",
    text: "حالا شما به مواد آموزشی دسترسی دارید.",
    buttonText: "برو به دوره",
  },
  coursePage: {
    courseType: {
      course: "دوره آموزشی",
      simulator: "مربی",
      webinar: "وبینار",
    },
    groupNumber: "{n} th جریان",
    manager: "مدیر",
    curator: "معلم",
    free: "رایگان است",
  },
  coursesPage: {
    materials: "مواد",
    schools: "مدارس نویسنده",
    universities: "دانشگاه ها",
    showPast: "نمایش رویدادهای گذشته",
    emptyList: "چنین مواد وجود ندارد",
    show: "نمایش",
    result1: "نتیجه",
    result2: "نتیجه",
    result5: "نتیجه",
    filters: "فیلترها",
    clear: "واضح",
  },
};
